import React from 'react'
import { Link } from 'react-router-dom';

const ClinicalStaff = () => {

  return (
    <main id="main" className="main">

		{/* Page Title Section */}
		<div className="pagetitle">
		  <h1>Clinical Staff</h1>
		  <nav>
			<ol className="breadcrumb">
			  <li className="breadcrumb-item"><Link to="/admin/dashboard">Home</Link></li>
			  <li className="breadcrumb-item active">Clinical Staff</li>
			</ol>
		  </nav>
		</div>
		{/* End Page Title Section */}

		{/* Page Content Section */}
		<section className="pagesection">
			<div className="row my-3">
				<div className="col-xxl-7 col-lg-7 d-flex">
					<div className="input-group input-group-sm me-2 w-50">
					  <input type="text" className="form-control" placeholder="Search" />
					  <button className="btn btn-tmBlue" type="button"><i className="ri-search-line"></i></button>
					</div>
				</div>
				<div className="col-xxl-5 col-lg-5">
					<Link to="/admin/add-clinical-staff" className="btn btn-sm btn-outline-tmBlue float-end">
						<i className="ri-add-box-fill align-middle"></i> Add Clinical Staff
					</Link>
					<div className="dropdown float-end me-3">
					  <a className="btn btn-sm btn-outline-tmBlue dropdown-toggle" href="javascript;" role="button" id="dropdownMenuLink" data-bs-toggle="dropdown" aria-expanded="false"> Sort by </a>

					  <ul className="dropdown-menu" aria-labelledby="dropdownMenuLink">
						<li><Link className="dropdown-item" to="#"> Highly Priority</Link></li>
						<li><Link className="dropdown-item" to="#"> Recently Added</Link></li>
						<li><Link className="dropdown-item" to="#"> Recently Updated</Link></li>
					  </ul>
					</div>
				</div>
			</div>
			<div className="row my-3">
				<div className="col-xxl-12">
					<div className="table-responsive">	
						<table className="table table-borderless theme-table">
							<thead>
							  <tr>
								<th scope="col">Staff Name</th>
								<th scope="col">Staff Role</th>
								<th scope="col">Contact Number</th>
								<th scope="col">Email Address</th>
								<th scope="col" className="text-center">Action</th>
							  </tr>
							</thead>
							<tbody>
								<tr>
									<td scope="row">
										<Link to="/admin/view-clinical-staff">
											<div className="d-flex align-items-center ps-1">
												<div className="avtar-img">
													<span className="rounded-circle"><img src="/assets/img/cl-staff-img1.png" alt="staff" /></span>
												</div>
												<div className="ms-2">
													<h5 className="table-title">Deepika Devi</h5>
												</div>
											</div>
										</Link>
									</td>					
									<td>Staff Nursing</td>	
									<td>+91 123 456 7890</td>							
									<td>emailaddrees@mail.com</td>												
									<td className="text-center fw-normal">
										<Link to="#" className="text-warning"><i className="ri-edit-2-line align-middle h6 me-2"></i> </Link>
										<Link to="#" className="text-danger"><i className="ri-delete-bin-7-line align-middle h6"></i></Link>
									</td>
								</tr>
								<tr>
									<td scope="row">
										<Link to="#">
											<div className="d-flex align-items-center ps-1">
												<div className="avtar-img">
													<span className="rounded-circle"><img src="/assets/img/cl-staff-img2.png" alt="staff" /></span>
												</div>
												<div className="ms-2">
													<h5 className="table-title">Kavya Madhavan</h5>
												</div>
											</div>
										</Link>
									</td>		
									<td>Nursing Assistant</td>	
									<td>+91 123 456 7890</td>							
									<td>emailaddrees@mail.com</td>												
									<td className="text-center fw-normal">
										<Link to="#" className="text-warning"><i className="ri-edit-2-line align-middle h6 me-2"></i> </Link>
										<Link to="#" className="text-danger"><i className="ri-delete-bin-7-line align-middle h6"></i></Link>
									</td>
								</tr>
								<tr>
									<td scope="row">
										<Link to="#">
											<div className="d-flex align-items-center ps-1">
												<div className="avtar-img">
													<span className="rounded-circle"><img src="/assets/img/cl-staff-img3.png" alt="staff" /></span>
												</div>
												<div className="ms-2">
													<h5 className="table-title">Arjun Das</h5>
												</div>
											</div>
										</Link>
									</td>		
									<td>Physical Therapy Assistant</td>	
									<td>+91 123 456 7890</td>							
									<td>emailaddrees@mail.com</td>												
									<td className="text-center fw-normal">
										<Link to="#" className="text-warning"><i className="ri-edit-2-line align-middle h6 me-2"></i> </Link>
										<Link to="#" className="text-danger"><i className="ri-delete-bin-7-line align-middle h6"></i></Link>
									</td>
								</tr>
								<tr>
									<td scope="row">
										<Link to="#">
											<div className="d-flex align-items-center ps-1">
												<div className="avtar-img">
													<span className="rounded-circle"><img src="/assets/img/cl-staff-img4.png" alt="staff" /></span>
												</div>
												<div className="ms-2">
													<h5 className="table-title">Abdul Hameed</h5>
												</div>
											</div>
										</Link>
									</td>		
									<td>Nurse Practitioner</td>	
									<td>+91 123 456 7890</td>							
									<td>emailaddrees@mail.com</td>												
									<td className="text-center fw-normal">
										<Link to="#" className="text-warning"><i className="ri-edit-2-line align-middle h6 me-2"></i> </Link>
										<Link to="#" className="text-danger"><i className="ri-delete-bin-7-line align-middle h6"></i></Link>
									</td>
								</tr>
								<tr>
									<td scope="row">
										<Link to="#">
											<div className="d-flex align-items-center ps-1">
												<div className="avtar-img">
													<span className="rounded-circle"><img src="/assets/img/cl-staff-img5.png" alt="staff" /></span>
												</div>
												<div className="ms-2">
													<h5 className="table-title">Devi Priya Sam</h5>
												</div>
											</div>
										</Link>
									</td>		
									<td>Nurse Practitioner</td>	
									<td>+91 123 456 7890</td>							
									<td>emailaddrees@mail.com</td>												
									<td className="text-center fw-normal">
										<Link to="#" className="text-warning"><i className="ri-edit-2-line align-middle h6 me-2"></i> </Link>
										<Link to="#" className="text-danger"><i className="ri-delete-bin-7-line align-middle h6"></i></Link>
									</td>
								</tr>
							</tbody>
						</table>
					</div>
				</div>
			</div>			
			<div className="row my-3">
				<div className="col-xxl-12">
					<nav aria-label="Page navigation ">
					  <ul className="pagination justify-content-center">
						<li className="page-item"><Link className="page-link" to="#">Prev</Link></li>
						<li className="page-item"><Link className="page-link" to="#">1</Link></li>
						<li className="page-item"><Link className="page-link" to="#">2</Link></li>
						<li className="page-item"><Link className="page-link" to="#">3</Link></li>
						<li className="page-item"><Link className="page-link" to="#">Next</Link></li>
					  </ul>
					</nav>
				</div>
			</div>
		</section>
		{/* End Page Content Section */}

	</main>
  )
}

export default ClinicalStaff
